/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationSettings } from './NotificationSettings';
import {
    NotificationSettingsFromJSON,
    NotificationSettingsFromJSONTyped,
    NotificationSettingsToJSON,
    NotificationSettingsToJSONTyped,
} from './NotificationSettings';

/**
 * 
 * @export
 * @interface PaginatedNotificationSettingsList
 */
export interface PaginatedNotificationSettingsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedNotificationSettingsList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationSettingsList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationSettingsList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<NotificationSettings>}
     * @memberof PaginatedNotificationSettingsList
     */
    results: Array<NotificationSettings>;
}

/**
 * Check if a given object implements the PaginatedNotificationSettingsList interface.
 */
export function instanceOfPaginatedNotificationSettingsList(value: object): value is PaginatedNotificationSettingsList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedNotificationSettingsListFromJSON(json: any): PaginatedNotificationSettingsList {
    return PaginatedNotificationSettingsListFromJSONTyped(json, false);
}

export function PaginatedNotificationSettingsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedNotificationSettingsList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(NotificationSettingsFromJSON)),
    };
}

  export function PaginatedNotificationSettingsListToJSON(json: any): PaginatedNotificationSettingsList {
      return PaginatedNotificationSettingsListToJSONTyped(json, false);
  }

  export function PaginatedNotificationSettingsListToJSONTyped(value?: PaginatedNotificationSettingsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(NotificationSettingsToJSON)),
    };
}

